module.exports = __webpack_public_path__ + "media/images/chara-matome-b69fab7911e1592d13e70981a47ed80e.png";